import { memo, useState, useContext } from 'react'
import StartBot from './StartBotHandler'

function App() {
  return (
    
      <StartBot />

    
  )
}

export default memo(App)